export default Object.freeze({
  MAIN_COPY: 'MAIN_COPY',
  REMOVE: 'REMOVE',
  KEEP: 'KEEP',
  UNRESOLVED: 'UNRESOLVED',
});
